import React from 'react';
import { WizardState } from '../../../hooks/useZakatWizard';
import { Input } from '../../ui/Input';
import { Select } from '../../ui/Select';
import { Card } from '../../ui/Card';
import { Button } from '../../ui/Button';
import { Plus, Trash2 } from 'lucide-react';
interface GoldSilverStepProps {
  state: WizardState;
  updateState: (updates: Partial<WizardState>) => void;
}
export function GoldSilverStep({
  state,
  updateState
}: GoldSilverStepProps) {
  // Gold Handlers
  const updateGold = (index: number, field: string, value: any) => {
    const newItems = [...state.goldItems];
    // @ts-ignore
    newItems[index][field] = value;
    updateState({
      goldItems: newItems
    });
  };
  const addGold = () => updateState({
    goldItems: [...state.goldItems, {
      purity: 24,
      weight: 0,
      unit: 'g'
    }]
  });
  const removeGold = (index: number) => updateState({
    goldItems: state.goldItems.filter((_, i) => i !== index)
  });
  // Silver Handlers
  const updateSilver = (index: number, field: string, value: any) => {
    const newItems = [...state.silverItems];
    // @ts-ignore
    newItems[index][field] = value;
    updateState({
      silverItems: newItems
    });
  };
  const addSilver = () => updateState({
    silverItems: [...state.silverItems, {
      purity: 999,
      weight: 0,
      unit: 'g'
    }]
  });
  const removeSilver = (index: number) => updateState({
    silverItems: state.silverItems.filter((_, i) => i !== index)
  });
  return <div className="space-y-6" data-id="element-372">
      <div className="mb-6" data-id="element-373">
        <h2 className="text-2xl font-bold text-gray-900 font-serif mb-2" data-id="element-374">
          Gold & Silver
        </h2>
        <p className="text-gray-600" data-id="element-375">
          Include jewelry, coins, and bullion. If you're unsure of the weight,
          you can estimate or use a kitchen scale.
        </p>
      </div>

      <Card title="Gold Assets" data-id="element-376">
        <div className="space-y-4" data-id="element-377">
          {state.goldItems.map((item, idx) => <div key={idx} className="space-y-3" data-id="element-378">
              {/* Labels row - show for every item on mobile, only first on desktop */}
              {idx === 0 && <div className="hidden md:grid md:grid-cols-[1fr_1fr_100px_32px] gap-3" data-id="element-379">
                  <span className="text-sm font-medium text-gray-700" data-id="element-380">
                    Purity
                  </span>
                  <span className="text-sm font-medium text-gray-700" data-id="element-381">
                    Weight
                  </span>
                  <span className="text-sm font-medium text-gray-700" data-id="element-382">
                    Unit
                  </span>
                  <span data-id="element-383"></span>
                </div>}

              {/* Mobile: label each item */}
              {idx > 0 && <div className="md:hidden border-t border-gray-100 pt-3 mt-3" data-id="element-384">
                  <span className="text-xs font-medium text-gray-500" data-id="element-385">
                    Item {idx + 1}
                  </span>
                </div>}

              <div className="grid grid-cols-[1fr_1fr] md:grid-cols-[1fr_1fr_100px_32px] gap-3 items-end" data-id="element-386">
                <div data-id="element-387">
                  <label className="md:hidden mb-1.5 block text-sm font-medium text-gray-700" data-id="element-388">
                    Purity
                  </label>
                  <Select options={[{
                value: '24',
                label: '24 Karat'
              }, {
                value: '22',
                label: '22 Karat'
              }, {
                value: '21',
                label: '21 Karat'
              }, {
                value: '18',
                label: '18 Karat'
              }, {
                value: '14',
                label: '14 Karat'
              }]} value={item.purity} onChange={e => updateGold(idx, 'purity', parseInt(e.target.value))} data-id="element-389" />
                </div>
                <div data-id="element-390">
                  <label className="md:hidden mb-1.5 block text-sm font-medium text-gray-700" data-id="element-391">
                    Weight
                  </label>
                  <Input type="number" placeholder="0" value={item.weight === 0 ? '' : item.weight} onChange={e => updateGold(idx, 'weight', parseFloat(e.target.value) || 0)} data-id="element-392" />
                </div>
                <div className="col-span-1" data-id="element-393">
                  <label className="md:hidden mb-1.5 block text-sm font-medium text-gray-700" data-id="element-394">
                    Unit
                  </label>
                  <Select options={[{
                value: 'g',
                label: 'Grams'
              }, {
                value: 'oz',
                label: 'Ounces'
              }]} value={item.unit} onChange={e => updateGold(idx, 'unit', e.target.value)} data-id="element-395" />
                </div>
                {state.goldItems.length > 1 && <button onClick={() => removeGold(idx)} className="p-2 text-gray-400 hover:text-red-500 self-end mb-0.5" data-id="element-396">
                    <Trash2 className="h-4 w-4" data-id="element-397" />
                  </button>}
              </div>
            </div>)}
          <Button variant="ghost" size="sm" onClick={addGold} className="text-teal-600" data-id="element-398">
            <Plus className="h-4 w-4 mr-1" data-id="element-399" /> Add Gold Item
          </Button>
        </div>
      </Card>

      <Card title="Silver Assets" data-id="element-400">
        <div className="space-y-4" data-id="element-401">
          {state.silverItems.map((item, idx) => <div key={idx} className="space-y-3" data-id="element-402">
              {idx === 0 && <div className="hidden md:grid md:grid-cols-[1fr_1fr_100px_32px] gap-3" data-id="element-403">
                  <span className="text-sm font-medium text-gray-700" data-id="element-404">
                    Purity
                  </span>
                  <span className="text-sm font-medium text-gray-700" data-id="element-405">
                    Weight
                  </span>
                  <span className="text-sm font-medium text-gray-700" data-id="element-406">
                    Unit
                  </span>
                  <span data-id="element-407"></span>
                </div>}

              {idx > 0 && <div className="md:hidden border-t border-gray-100 pt-3 mt-3" data-id="element-408">
                  <span className="text-xs font-medium text-gray-500" data-id="element-409">
                    Item {idx + 1}
                  </span>
                </div>}

              <div className="grid grid-cols-[1fr_1fr] md:grid-cols-[1fr_1fr_100px_32px] gap-3 items-end" data-id="element-410">
                <div data-id="element-411">
                  <label className="md:hidden mb-1.5 block text-sm font-medium text-gray-700" data-id="element-412">
                    Purity
                  </label>
                  <Select options={[{
                value: '999',
                label: '999 (Fine)'
              }, {
                value: '925',
                label: '925 (Sterling)'
              }, {
                value: '900',
                label: '900 (Coin)'
              }]} value={item.purity} onChange={e => updateSilver(idx, 'purity', parseInt(e.target.value))} data-id="element-413" />
                </div>
                <div data-id="element-414">
                  <label className="md:hidden mb-1.5 block text-sm font-medium text-gray-700" data-id="element-415">
                    Weight
                  </label>
                  <Input type="number" placeholder="0" value={item.weight === 0 ? '' : item.weight} onChange={e => updateSilver(idx, 'weight', parseFloat(e.target.value) || 0)} data-id="element-416" />
                </div>
                <div className="col-span-1" data-id="element-417">
                  <label className="md:hidden mb-1.5 block text-sm font-medium text-gray-700" data-id="element-418">
                    Unit
                  </label>
                  <Select options={[{
                value: 'g',
                label: 'Grams'
              }, {
                value: 'oz',
                label: 'Ounces'
              }]} value={item.unit} onChange={e => updateSilver(idx, 'unit', e.target.value)} data-id="element-419" />
                </div>
                {state.silverItems.length > 1 && <button onClick={() => removeSilver(idx)} className="p-2 text-gray-400 hover:text-red-500 self-end mb-0.5" data-id="element-420">
                    <Trash2 className="h-4 w-4" data-id="element-421" />
                  </button>}
              </div>
            </div>)}
          <Button variant="ghost" size="sm" onClick={addSilver} className="text-teal-600" data-id="element-422">
            <Plus className="h-4 w-4 mr-1" data-id="element-423" /> Add Silver Item
          </Button>
        </div>
      </Card>
    </div>;
}